import { render } from "./BarcodeLabel.vue?vue&type=template&id=46bb4812&scoped=true"
import script from "./BarcodeLabel.vue?vue&type=script&lang=ts"
export * from "./BarcodeLabel.vue?vue&type=script&lang=ts"

import "./BarcodeLabel.vue?vue&type=style&index=0&id=46bb4812&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-46bb4812"

export default script